import { Injectable } from '@angular/core';
import { CanDeactivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from '../../core/interfaces/component-can-deactivate';
import { ConfirmationComponent } from '../components/confirmation/confirmation.component';
import { MatDialog } from '@angular/material/dialog';
import { TslDialog } from '@tesla/ng-tds';
import { I18nService } from '../services/i18n.service';

@Injectable({
  providedIn: 'root'
})

export class UnSavedGuard implements CanDeactivate<ComponentCanDeactivate> {

  constructor(private dialog: TslDialog, private translate: I18nService) {

  }

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    if (component.isDirty()) {
      var confirmation = this.dialog.confirm(this.translate.get('You have unsaved changes'), this.translate.get('You are about to leave this page. All Unsaved changes will be lost. Are you sure you want to leave?'), this.translate.get('Continue'), this.translate.get('Cancel'));
      return confirmation.afterClosed().map(confirmed => {
        return confirmed;
      });
    } else {
      return true;
    }
  }
}